import { productionPlans } from "@/api/productionPlan/useProductionPlanQuery";
import { LotTrackingLedgerTrackingContent } from "@/features/lotTracking/components/ledgerTracking";
import { LotTrackingForwardItemContent } from "@/features/lotTracking/forward/components/forwardItem";
import { LotTrackingForwardLedgerTracking } from "@/features/lotTracking/forward/components/forwardLedgerTacking";
import { LotTrackingForwardSummaryContent } from "@/features/lotTracking/forward/components/forwardSummary";
import { LotTrackingForwardWorkHistoryContent } from "@/features/lotTracking/forward/components/forwardWorkHistory";
import { LotTrackingForwardActionHeader } from "@/features/lotTracking/forward/header/lotTrackingActionHeader";
import { useLotTrackingActions } from "@/features/lotTracking/hook/useLotTrackingActions";
import { useLotTrackingState } from "@/features/lotTracking/hook/useLotTrackingState";
import { Flex, Text, Title } from "@mantine/core";
import { ProductionPlansConsumedLotIdLotIdGet200Response } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const LotTrackingForwardPage = () => {
  const state = useLotTrackingState();
  const actions = useLotTrackingActions();
  const location = useLocation();

  useEffect(() => {
    // 필요한 경우 조건 추가
    if (state.itemCodeValue && state.lotId && location.state?.value === "click") {
      actions.setProductionPlan(undefined);
    } else if (state.itemCodeValue || state.lotId || state.productionPlan) {
      actions.setProductionPlan(undefined);
      actions.setLotId(null);
      actions.setItemCodeValue(null);
    }
  }, []);

  const { data: consumedLot } = useQuery({
    ...productionPlans.consumedLot({
      lotId: Number(state.lotId),
    }),
    enabled: !!state.lotId,
  });

  return (
    <Flex w="100%" h="100%" direction="column">
      <Flex px="sm">
        <LotTrackingForwardActionHeader />
      </Flex>
      <Flex direction="column">
        <Title p={"sm"} mb={8} order={1}>
          정방향 로트 추적
        </Title>
        <Text fz={12} p={"sm"}>
          특정 로트로 생산된 모든 제품의 로트를 파악할 수 있는 페이지입니다.
        </Text>
        <LotTrackingForwardItemContent />
        <LotTrackingForwardSummaryContent
          consumedLotData={consumedLot?.data as ProductionPlansConsumedLotIdLotIdGet200Response[]}
        />
        <LotTrackingForwardWorkHistoryContent />
        <LotTrackingLedgerTrackingContent
          consumedLotData={consumedLot?.data as ProductionPlansConsumedLotIdLotIdGet200Response[]}
        />
        <LotTrackingForwardLedgerTracking />
        {/* <LotTrackingQualityHistoryContent /> */}
      </Flex>
    </Flex>
  );
};
